import _slicedToArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect, useState } from 'react';
import GuardState from './GuardState';
import { useAuthentication } from '../../hooks/useAuthentication';
import { useIdentity } from '../../hooks/useIdentity';
import { ComponentKind, ComponentRender } from '../../ui/Component';

var AuthGuard = function AuthGuard(props) {
  var children = props.children,
      role = props.role,
      Fallback = props.fallback;
  var authentication = useAuthentication();
  var currentUser = useIdentity();
  var logged = currentUser !== undefined;

  var _useState = useState(GuardState.UNKNOWN),
      _useState2 = _slicedToArray(_useState, 2),
      guardValid = _useState2[0],
      setGuard = _useState2[1];

  useEffect(function () {
    if (!logged || !currentUser) {
      setGuard(GuardState.NO_LOGIN);
    } else if (!role || currentUser.suitableFor(role)) {
      setGuard(GuardState.ALLOWED);
    } else {
      setGuard(GuardState.REJECTED);
    }
  }, [setGuard, logged, currentUser]);
  useEffect(function () {
    if (guardValid === GuardState.NO_LOGIN) {
      authentication.login();
    }
  }, [guardValid]);

  if (guardValid === GuardState.ALLOWED) {
    return React.createElement(React.Fragment, null, children);
  }

  if (guardValid === GuardState.REJECTED) {
    return React.createElement(ComponentRender, {
      kind: ComponentKind.ACCESS_DENIED
    });
  }

  return React.createElement(Fallback, null);
};

export default AuthGuard;